module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"buy":"Купить","all_parfumes":"Вся парфюмерия","online":"онлайн","to_shop":"В магазин"}}')
  delete Component.options._Ctor
}
